// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetWidgetEventDetailRequestModel from '../../model/get-widget-event-detail-request-model';
import GetWidgetEventDetailRequestDTO from '../dto/get-widget-event-detail-request-dto';
import dtoSchema from '../schemas/get-widget-event-detail-request-schema';

export default abstract class GetWidgetEventDetailRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetWidgetEventDetailRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int32}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetWidgetEventDetailRequestDTO>): GetWidgetEventDetailRequestModel;
  static toModel(dto: DeepPartial<GetWidgetEventDetailRequestDTO> | undefined | null): GetWidgetEventDetailRequestModel | undefined;
  static toModel(dto: DeepPartial<GetWidgetEventDetailRequestDTO> | undefined | null): GetWidgetEventDetailRequestModel | undefined {
    return dto ? new GetWidgetEventDetailRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetWidgetEventDetailRequestModel> | GetWidgetEventDetailRequestModel): GetWidgetEventDetailRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetWidgetEventDetailRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetWidgetEventDetailRequestModel, can not map to GetWidgetEventDetailRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
